import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import { Row, Col } from "react-bootstrap";
import ShowCustomerInfo from "./ShowCustomerInfo";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReservationItems from "./Reservations/ReservationItems";
import ReservationChat from "./ReservationChat";
import ReservationHistory from "./ReservationHistory";
import Messages from ".//Messages";
import SwitchLabelButton from "./SwitchLabelButton";
import { postPhoneOrEmailConfirmation } from "../actions/reservationsActions";
import ReservationScreen from "../screens/ReservationScreen";
import { ModernButton } from "./DefaultImports";
import ReservationTableNameSelector from "./Reservations/ReservationTableNameSelector";
import ReservationStatusChanger from "./Reservations/ReservationStatusChanger";
import { ConfirmationModal } from "./ConfirmationModal";
import { customerAttendUpdateSlice } from "../reducers/restaurantReducers";
import Tooltip from "./ToolTipWrapper";

import {
  faCircleXmark,
  faFilePen,
  faLock,
  faNoteSticky,
} from "@fortawesome/free-solid-svg-icons";
import { useSelector, useDispatch } from "react-redux";
import {
  NoPhoneSvgIcon,
  PhoneSvgIcon,
  UserSvgIcon,
  NoPhoneTwoLinesSvgIcon,
  NoEmailTwoLinesSvgIcon,
  NoEmailSvgIcon,
  EmailSvgIcon,
} from "../icons/SvgIcons";
import moment from "moment-timezone";
import { CustomModal } from "./CustomModal";

const ReservationGrid = styled.div`
  display: grid;
`;

const ReservationTop = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 35px;
  background-color: #99b0ad;
  color: #faf6e9;
  /*   background-color: ${(props) =>
    props.status === "Cancelled" ||
    props.status === "Cancelled_By_Customer" ||
    props.status === "Cancelled_By_Restaurant" ||
    props.status === "Did_Not_Attend"
      ? "#e8733c"
      : props.status === "Edited"
        ? "#7e538a"
        : props.status === "Pending_from_restaurant"
          ? "#cacf44"
          : props.status === "Pending_from_customer"
            ? "#959657"
            : props.status === "Late"
              ? "#ebb052"
              : "#58c49f"}; */
`;

const CustomRow = styled.div`
  margin: 0 !important;
  padding: 0 !important;
  width: 100%;
  height: auto;
  align-items: center;
  display: flex; /* Ensures flex properties apply correctly */
`;

const ReservationTitle = styled.h2`
  display: flex;
  font-size: 1rem;
  color: ${(props) =>
    props.status === "Cancelled"
      ? "#FAF6E9"
      : props.status === "Pending_from_restaurant"
        ? "black"
        : props.status === "Edited"
          ? "#FAF6E9"
          : "#FAF6E9"};
  margin-top: 4px;
  margin-left: 5px;
`;

const ReservationBotItems = styled.div`
  display: flex;
  margin: 5px;
  font-size: 18px;
`;

const ReservationBotItemsContainer = styled.div`
  display: flex;
  width: 100%;
`;

const ReservationBot = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
  height: auto;
`;

const ReservationBoxWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 5px;
  margin: 0;
  width: 100%;
`;

const ReservationCardStyle = styled.div`
  display: flex;
  flex-wrap: wrap;
  background-color: white;
  border: 1px solid #cbd1cf;
  border-radius: 5px;
  padding: 0;
  position: relative;
  overflow: hidden;
  width: 100%;
  max-height: 400px;
  margin-bottom: 4px;
  padding-bottom: 0px;
`;

const ReservationCard = React.memo(
  ({
    reservations,
    reservations_complete,
    isShowCustomerInfo = false,
    isNotifications = false,
    isReservationFromRestaurantScreen = false,
    dispatch_reservation_wait = 0,
    past_estimated_time = false,
  }) => {
    const dispatch = useDispatch();

    const today = new Date();
    const formattedToday = `${today.getFullYear()}-${String(
      today.getMonth() + 1,
    ).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
    const [isShowCustomerInfoModalActive, setIsShowCustomerInfoModalActive] =
      useState(false);
    const [isReservationModalOpen, setIsReservationModalOpen] = useState(false);
    const [isCreatingReservation, setIsCreatingReservation] = useState(false);
    const [tokens, setTokens] = useState("");
    const [reservation_or_waiting_list, setReservation_or_waiting_list] =
      useState("reservation");
    const [statusFilter, setStatusFilter] = useState("Aceite");

    const [showPhoneModal, setShowPhoneModal] = useState(false);
    const [phoneIsConfirmed, setPhoneIsConfirmed] = useState(false);
    const [completePhone, setCompletePhone] = useState("");

    const [current_reservation_id, setCurrent_reservation_id] = useState("");
    const [customer_name, setCustomer_name] = useState("");

    const [isWaiting, setIsWaiting] = useState(false);

    const manager_info = useSelector((state) => state.crudManager);
    const { managerInfo } = manager_info;

    const reservationsFromRestaurant = useSelector(
      (state) => state.reservationsFromRestaurant,
    );
    const { error } = reservationsFromRestaurant;

    const customerAttendUpdates = useSelector(
      (state) => state.customerAttendUpdate,
    );
    const { errorChangeTableNumber } = customerAttendUpdates;

    const restaurant_info = useSelector((state) => state.restaurantDetails);
    const { restaurants } = restaurant_info;

    const reservationZone = useSelector((state) => state.reservationZone);
    const { zones, isZonesLoading, zonesError } = reservationZone;

    const all_tables = useSelector((state) => state.restaurantTables.tables);

    const [reservationTokenToPhoneLink, setReservationTokenToPhoneLink] =
      useState("");

    const [reservationHasBeenModified, setReservationHasBeenModified] =
      useState(false);

    const [
      modalReservationModifyReservation,
      setModalReservationModifyReservation,
    ] = useState(false);

    const handleSetPhoneNumber = (
      country_code,
      phone_number,
      reservationID,
      isPhoneConfirmed,
      the_customer_name,
      reservation_token,
    ) => {
      const countryCode = country_code;
      const phoneNumber = phone_number;
      const countryCodeLength = countryCode.length;
      const formattedPhoneNumber = phoneNumber.startsWith(countryCode)
        ? countryCode + " " + phoneNumber.slice(countryCodeLength)
        : phoneNumber;

      setCompletePhone(formattedPhoneNumber);
      setShowPhoneModal(!showPhoneModal);
      setCurrent_reservation_id(reservationID);
      setPhoneIsConfirmed(isPhoneConfirmed);
      setCustomer_name(the_customer_name);
      setReservationTokenToPhoneLink(reservation_token);
    };

    const UpdatePhoneNumber = () => {
      dispatch(postPhoneOrEmailConfirmation(current_reservation_id, "phone"));
    };
    const showCustomerInfo = (country_code, phone_number) => {
      const countryCode = country_code;
      const phoneNumber = phone_number;
      const countryCodeLength = countryCode.length;
      const formattedPhoneNumber = phoneNumber.startsWith(countryCode)
        ? countryCode + " " + phoneNumber.slice(countryCodeLength)
        : phoneNumber;
      setCompletePhone(phone_number);
      setIsShowCustomerInfoModalActive(true);
    };

    const handleSetEmail = (
      country_code,
      email_here,
      reservationID,
      isPhoneConfirmed,
      the_customer_name,
      reservation_token,
    ) => {
      const email = email;

      setCurrent_reservation_id(reservationID);
      setCustomer_name(the_customer_name);
      setReservationTokenToPhoneLink(reservation_token);
    };

    const handleOpenEditReservationModal = (tokeni) => {
      setIsReservationModalOpen(true);
      setIsCreatingReservation(false);
      setReservation_or_waiting_list("reservation");
      setTokens(tokeni);
    };

    const handleCloseReservationModal = () => {
      setIsReservationModalOpen(false);
      setTokens();
    };

    return (
      <ReservationGrid>
        {reservations && reservations.length > 0 && restaurants ? (
          reservations.map((reservation, index) => {
            const combinedDateTime = `${reservation.date} ${reservation.time}`;
            const reservationDateTime = moment.tz(
              combinedDateTime,
              "YYYY-MM-DD HH:mm",
              restaurants.timezone,
            );

            // ✅ Lógica adicional:
            const currentDateTime = moment.tz(restaurants.timezone);

            const isPastReservation =
              reservationDateTime.isBefore(currentDateTime);
            const isTodayOrPast = reservationDateTime
              .clone()
              .startOf("day")
              .isSameOrBefore(currentDateTime.clone().startOf("day"));

            return (
              <ReservationCardStyle key={reservation.id}>
                <ReservationTop status={reservation.status}>
                  <CustomRow>
                    <Col
                      xs={6}
                      md={isShowCustomerInfo || isNotifications ? 6 : 9}
                      style={{
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        display: "flex",
                        alignItems: "center", // Vertically align items
                        justifyContent: "flex-start", // Align items to the start horizontally
                        paddingTop: "4px",
                      }}
                    >
                      <ReservationTitle
                        status={reservation.status}
                        onClick={() =>
                          showCustomerInfo(
                            reservation.country_code,
                            reservation.phone_number,
                          )
                        }
                        style={{ cursor: "pointer", color: "#FAF6E9" }}
                      >
                        <UserSvgIcon
                          width={20}
                          height={20}
                          strokeColor={"#FAF6E9"}
                          style={{ marginRight: "10px", paddingTop: "1px" }}
                        />
                        <div style={{ paddingTop: "3px" }}>
                          {reservation.full_name}
                        </div>
                      </ReservationTitle>
                    </Col>

                    <Col
                      xs={6}
                      md={isShowCustomerInfo || isNotifications ? 6 : 3}
                      style={{
                        display: "flex",
                        alignItems: "center", // Vertically align items
                        justifyContent: "space-between", // Align items to the end horizontally
                        paddingBottom: "3px",
                        paddingRight: "3px",
                      }}
                    >
                      {!isShowCustomerInfo ? (
                        <>
                          {!reservation.phone_number || // null, undefined, etc
                          reservation.phone_number.trim() === "" || // vazio
                          reservation.phone_number.trim().length <= 3 ? ( // apenas código do país como "351"
                            // 🔴 No Number
                            <a
                              title="Sem número de telefone"
                              style={{ color: "#FAF6E9", fontSize: "20px" }}
                              onClick={() =>
                                handleSetPhoneNumber(
                                  reservation.country_code,
                                  reservation.phone_number, // mesmo sendo só "351"
                                  reservation.id,
                                  reservation.is_phone_confirmed,
                                  reservation.full_name,
                                  reservation.token,
                                )
                              }
                            >
                              <NoPhoneTwoLinesSvgIcon
                                width={30}
                                height={28}
                                strokeColor={"#FAF6E9"}
                              />
                            </a>
                          ) : reservation.is_phone_confirmed ? (
                            // ✅ Number Confirmed
                            <a
                              title="Telefone confirmado"
                              style={{ color: "white", cursor: "pointer" }}
                              onClick={() =>
                                handleSetPhoneNumber(
                                  reservation.country_code,
                                  reservation.phone_number,
                                  reservation.id,
                                  reservation.is_phone_confirmed,
                                  reservation.full_name,
                                  reservation.token,
                                )
                              }
                            >
                              <PhoneSvgIcon
                                width={30}
                                height={28}
                                strokeColor={"#FAF6E9"}
                              />
                            </a>
                          ) : (
                            // ⚠️ Number Not Confirmed
                            <a
                              title="Telefone não confirmado"
                              style={{ color: "white", cursor: "pointer" }}
                              onClick={() =>
                                handleSetPhoneNumber(
                                  reservation.country_code,
                                  reservation.phone_number,
                                  reservation.id,
                                  reservation.is_phone_confirmed,
                                  reservation.full_name,
                                  reservation.token,
                                )
                              }
                            >
                              <NoPhoneSvgIcon
                                width={30}
                                height={28}
                                strokeColor={"#FAF6E9"}
                              />
                            </a>
                          )}
                        </>
                      ) : null}

                      {!isShowCustomerInfo ? (
                        <>
                          {!reservation.email || // null, undefined, etc
                          reservation.email.trim() === "" ? (
                            // 🔴 No Email
                            <a
                              title="Sem email"
                              style={{ color: "#FAF6E9", fontSize: "20px" }}
                              onClick={() =>
                                handleSetEmail(
                                  reservation.email,
                                  reservation.id,
                                  reservation.is_email_confirmed,
                                  reservation.full_name,
                                  reservation.token,
                                )
                              }
                            >
                              <NoEmailTwoLinesSvgIcon
                                width={30}
                                height={28}
                                strokeColor={"#FAF6E9"}
                              />
                            </a>
                          ) : reservation.is_email_confirmed ? (
                            // ✅ Email Confirmed
                            <a
                              title="Email confirmado"
                              style={{ color: "white", cursor: "pointer" }}
                              onClick={() =>
                                handleSetEmail(
                                  reservation.email,
                                  reservation.id,
                                  reservation.is_email_confirmed,
                                  reservation.full_name,
                                  reservation.token,
                                )
                              }
                            >
                              <EmailSvgIcon
                                width={30}
                                height={28}
                                strokeColor={"#FAF6E9"}
                              />
                            </a>
                          ) : (
                            // ⚠️ Email Not Confirmed
                            <a
                              title="Email não confirmado"
                              style={{ color: "white", cursor: "pointer" }}
                              onClick={() =>
                                handleSetEmail(
                                  reservation.email,
                                  reservation.id,
                                  reservation.is_email_confirmed,
                                  reservation.full_name,
                                  reservation.token,
                                )
                              }
                            >
                              <NoEmailSvgIcon
                                width={30}
                                height={28}
                                strokeColor={"#FAF6E9"}
                              />
                            </a>
                          )}
                        </>
                      ) : null}

                      <ReservationChat reservation={reservation} />

                      {zones && (
                        <ReservationHistory
                          reservationHistory={reservation.history}
                          timezone={restaurants.timezone}
                          all_tables={all_tables}
                          zones_with_id={zones.zones_with_id}
                        />
                      )}

                      {reservation.status !== "Cancelled" &&
                      new Date(reservation.date) >=
                        new Date(
                          new Date().setDate(new Date().getDate() - 2),
                        ) &&
                      ((managerInfo && managerInfo.edit_reservations) ||
                        !managerInfo) ? (
                        <div
                          onClick={() =>
                            handleOpenEditReservationModal(reservation.token)
                          }
                        >
                          <FontAwesomeIcon
                            icon={faFilePen}
                            style={{
                              color: "#FAF6E9",
                              fontSize: "25px",
                              paddingTop: "5px",
                              cursor: "pointer",
                            }}
                          />
                        </div>
                      ) : (
                        <>
                          {" "}
                          <FontAwesomeIcon
                            icon={faLock}
                            style={{
                              color: "#FAF6E9",
                              fontSize: "25px",
                              paddingTop: "5px",
                            }}
                          />
                        </>
                      )}
                    </Col>
                  </CustomRow>
                </ReservationTop>
                <Row style={{ width: "100%", padding: "0", margin: "0" }}>
                  <Col
                    xs={12}
                    md={isNotifications ? 12 : isShowCustomerInfo ? 12 : 7}
                    style={{ width: "100%", padding: "0", margin: "0" }}
                  >
                    <ReservationItems
                      reservation={reservation}
                      all_tables={all_tables}
                      previousReservationFromHistory={false}
                      isReservationFromRestaurantScreen={
                        isReservationFromRestaurantScreen
                      }
                    />
                  </Col>
                  <Col
                    xs={12}
                    style={{ width: "100%", padding: "0", margin: "0" }}
                  >
                    <ReservationStatusChanger
                      past_estimated_time={past_estimated_time}
                      reservation={reservation}
                      index={reservation.id}
                      setTokens={setTokens}
                      isShowCustomerInfo={isShowCustomerInfo}
                    />
                  </Col>
                  <ReservationTableNameSelector
                    reservation={reservation}
                    reservations={reservations_complete}
                    dispatch_reservation_wait={dispatch_reservation_wait}
                  />
                </Row>
                {reservation.restaurant_note.length > 0 && (
                  <div
                    style={{
                      position: "absolute",
                      right: "5px",
                      bottom: "39px",
                    }}
                  >
                    <Tooltip text={"Nota: " + reservation.restaurant_note}>
                      <FontAwesomeIcon
                        icon={faNoteSticky}
                        size="xl"
                        style={{ color: "#99B0AD", marginRight: "4px" }}
                      />
                    </Tooltip>
                  </div>
                )}
              </ReservationCardStyle>
            );
          })
        ) : error ? (
          <Messages variant="error">{error}</Messages>
        ) : (
          <p>Não foi encontrada nenhuma reserva para os filtros definidos.</p>
        )}

        <CustomModal
          show={showPhoneModal}
          onHide={() => setShowPhoneModal(false)}
          title="Telefonar para cliente"
          centered={false}
          footer={
            <>
              {completePhone.length > 4 ? (
                <a
                  href={`tel:${"+" + completePhone}`}
                  style={{ cursor: "pointer", textDecoration: "none" }}
                >
                  <ModernButton color="#99B0AD" fontSize="14px">
                    Telefonar
                  </ModernButton>
                </a>
              ) : (
                <ModernButton
                  color="#99B0AD"
                  fontSize="14px"
                  style={{ border: "none" }}
                  disabled={true}
                >
                  Telefonar
                </ModernButton>
              )}

              <ModernButton
                color="#EE754C"
                fontSize="14px"
                onClick={() =>
                  handleOpenEditReservationModal(reservationTokenToPhoneLink)
                }
              >
                Editar número de telemóvel
              </ModernButton>
            </>
          }
        >
          <div style={{ paddingTop: "5px" }}>
            <div
              style={{
                fontSize: "20px",
                fontWeight: "600",
                marginBottom: "12px",
                color: "#9FBBC1",
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <span>{customer_name}</span>
              {completePhone.length > 4 && (
                <span>
                  +{completePhone.slice(0, 3)} {completePhone.slice(3)}
                </span>
              )}
            </div>

            {completePhone.length <= 4 && (
              <div
                style={{
                  fontSize: "20px",
                  fontWeight: "600",
                  color: "#999",
                  marginBottom: "12px",
                }}
              >
                Sem número de telemóvel associado
              </div>
            )}

            {completePhone.length > 4 && (
              <div style={{ marginTop: "5px" }}>
                <SwitchLabelButton
                  leftText="Não confirmado"
                  rightText="Confirmado"
                  onToggle={UpdatePhoneNumber}
                  defaultState={phoneIsConfirmed}
                />
              </div>
            )}
          </div>
        </CustomModal>

        {!isShowCustomerInfo && (
          <ShowCustomerInfo
            phone_number={completePhone}
            restaurant_id={restaurants.id}
            isModalActive={isShowCustomerInfoModalActive}
            setIsModalActive={setIsShowCustomerInfoModalActive}
          />
        )}

        {isReservationModalOpen && (
          <CustomModal
            show={isReservationModalOpen}
            scrollable
            onHide={() => {
              if (reservationHasBeenModified) {
                setModalReservationModifyReservation(true);
              } else {
                setIsReservationModalOpen(false);
              }
            }}
            title={isCreatingReservation ? "Nova reserva" : "Editar reserva"}
            centered={false}
            body={
              <ReservationScreen
                from_restaurant={true}
                creating={isCreatingReservation}
                setCreating={setIsCreatingReservation}
                isEditModalOpen={isReservationModalOpen}
                setIsEditModalOpen={setIsReservationModalOpen}
                restaurantId={restaurants.id}
                handleCloseReservationModal={handleCloseReservationModal}
                token_from_restaurant={tokens}
                setTokens={setTokens}
                reservation_or_waiting_list={reservation_or_waiting_list}
                setReservationHasBeenModified={setReservationHasBeenModified}
                reservationHasBeenModified={reservationHasBeenModified}
                modalReservationModifyReservation={
                  modalReservationModifyReservation
                }
                setModalReservationModifyReservation={
                  setModalReservationModifyReservation
                }
                no_border={true}
              />
            }
          />
        )}
        <ConfirmationModal
          show={errorChangeTableNumber}
          onHide={() => {
            dispatch(
              customerAttendUpdateSlice.actions.resetChangeTableNumber(),
            );
          }}
          title="Erro"
          body={<>Por favor tenta novamente.</>}
          confirmLabel={<>ok</>}
          confirmColor="#EE754C"
          onConfirm={() => {
            dispatch(
              customerAttendUpdateSlice.actions.resetChangeTableNumber(),
            );
          }}
        />
      </ReservationGrid>
    );
  },
);

export default ReservationCard;
